<template>
  <Dialog
    class="dialog-without-title dialog-content-p-0"
    v-model:visible="visible"
    :style="{width: '516px'}"
    :modal="true"
    @hide="close()"
  >
    <div class="wrapper">
      <div class="icon-warning"></div>
      <h4 class="title">Are you sure you want to exit?</h4>
      <div class="text">You can save your progress <br> and continue later.</div>
      <div class="buttons p-fluid">
        <div class="p-col">
          <Button label="Exit without saving" class="p-button-secondary p-button-md" @click="emit('exit')" />
        </div>

        <div class="p-col">
          <Button label="Save and exit" class="p-button-md" @click="emit('save')" />
        </div>
      </div>
    </div>

    <template #footer />
  </Dialog>
</template>

<script setup>
import {defineEmits, defineProps, ref, watch} from "vue";

const emit = defineEmits(['update:visible', 'save', 'exit']);
const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
    required: true
  },
});

const visible = ref(props.visible);

watch(() => visible, (newValue) => emit('update:visible', newValue))
watch(() => props.visible, (newValue) => visible.value = newValue)

const close = () => emit('update:visible', false)

</script>

<style lang="scss" scoped>
@import "../../../assets/sass/theme_variables";

.wrapper {
  text-align: center;
  padding-left: toRem(70);
  padding-right: toRem(70);
}

.icon-warning {
  display: inline-block;
}

.title {
  margin-bottom: 0;
  margin-top: toRem(8);
  font-weight: bold;
}

.text {
  margin-top: toRem(8);
  font-size: toRem(18);
}

.buttons {
  display: flex;
  margin-top: toRem(24);
}

.p-dialog-content {
  padding: 0;
}



</style>
